import { FC } from 'react';
import './pdf-worker';
import './video-record';
import './pdf-component';

const WebComponents: FC = () => null;
export default WebComponents;
